import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-first-trimester',
  templateUrl: './first-trimester.component.html',
  styleUrls: ['./first-trimester.component.scss']
})
export class FirstTrimesterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
